/* ReQaf PDP quantity stepper.
 * Each [data-reqaf-qty] is self-contained: tapping ± updates its own input
 * value AND its own ATC button's total label (looked up via the nearest
 * .reqaf-buybox or .reqaf-mobile-cta wrapper). */

(function () {
  function moneyFormat(cents) {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney && window.Shopify.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getInput(stepper) {
    return stepper.querySelector('[data-reqaf-qty-input]');
  }

  function getQty(stepper) {
    const input = getInput(stepper);
    if (!input) return 1;
    const v = parseInt(input.value, 10);
    return isNaN(v) || v < 1 ? 1 : v;
  }

  function updateTotal(stepper, qty) {
    const unit = parseInt(stepper.getAttribute('data-unit-price'), 10);
    if (isNaN(unit)) return;
    const root = stepper.closest('.reqaf-buybox, .reqaf-mobile-cta');
    if (!root) return;
    const totalEl = root.querySelector('[data-reqaf-atc-total]');
    if (totalEl) totalEl.textContent = moneyFormat(unit * qty);
  }

  function setQty(stepper, qty) {
    const safe = qty < 1 ? 1 : qty;
    const input = getInput(stepper);
    if (input) {
      input.value = safe;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateTotal(stepper, safe);
  }

  function bindStepper(stepper) {
    const dec = stepper.querySelector('[data-reqaf-qty-decrement]');
    const inc = stepper.querySelector('[data-reqaf-qty-increment]');
    const input = getInput(stepper);

    if (dec) dec.addEventListener('click', () => setQty(stepper, getQty(stepper) - 1));
    if (inc) inc.addEventListener('click', () => setQty(stepper, getQty(stepper) + 1));
    if (input) {
      input.addEventListener('change', () => {
        const v = parseInt(input.value, 10);
        setQty(stepper, isNaN(v) || v < 1 ? 1 : v);
      });
    }
    updateTotal(stepper, getQty(stepper));
  }

  function boot() {
    document.querySelectorAll('[data-reqaf-qty]').forEach(bindStepper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
